import { useGlobalContext } from '../contextoGlobal'

export const useBlackFriday = () => {
  const { isBlackFridayTheme } = useGlobalContext()

  return {
    isBlackFridayTheme,
  }
}
